<template>
	<ul class="pagination mt-3 mb-0" v-if="shouldPaginate">
		<li v-show="prevPageUrl" class="page-item">
			<a href="#" aria-label="Previous" rel="prev" @click.prevent="setCurrentPage(currentPage-1)">
				<span aria-hidden="true">&laquo; Prev</span>
			</a>
		</li>
		<li v-show="nextPageUrl" class="page-item">
			<a href="#" aria-label="Next" rel="next" @click.prevent="setCurrentPage(currentPage+1)">
				<span aria-hidden="true">Next &raquo;</span>
			</a>
		</li>
	</ul>
</template>

<script>
export default {
	props: ['dataSet'],

	data() {
		return {
			currentPage: 1,
			prevPageUrl: null,
			nextPageUrl: null,
		}
	},

	watch: {
		dataSet() {
			this.currentPage = this.dataSet.current_page
			this.prevPageUrl = this.dataSet.prev_page_url
			this.nextPageUrl = this.dataSet.next_page_url
		},

		// currentPage() {
		//     this.broadcast()
		//     this.updateUrl()
		// },
	},

	computed: {
		shouldPaginate() {
			return !!this.prevPageUrl || !!this.nextPageUrl
		},
	},

	methods: {
		setCurrentPage(page) {
			this.currentPage = page
            this.$emit('updated', this.currentPage)
            this.updateUrl()
		},

		updateUrl() {
			var path = location.href.replace(/\?page=(\d+)/, '')
			history.pushState(null, null, `${path}?page=${this.currentPage}`)
		},
	},
}
</script>
